export interface IBulkSavedExportSettingsMutationPayload {
  format: 0 | 1;
  cubeId: string;
  name: string;
  dimensions: Array<{
    id: string;
    selection: unknown[];
    fieldName: string;
    isSelected: boolean;
  }>;
  measures: Array<{
    id: string;
    fieldName: string;
    isSelected: boolean;
  }>;
}
export enum BulkExportFormatEnum {
  xlsx = 0,
  csv = 1,
} 